var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.4,
    height: 42.4,
    viewBox: "0 0 42.4 42.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3952",
    "data-name": "Group 3952",
    transform: "translate(-0.3 -0.3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1.5 1.5)",
    fill: "none",
    stroke: "#005492",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3953",
    "data-name": "Group 3953"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    y2: 12,
    transform: "translate(21.5 11.5)",
    fill: "none",
    stroke: "#005492",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M28.6,37.138a2,2,0,1,1-2-2,2,2,0,0,1,2,2",
    transform: "translate(-5.1 -7.638)",
    fill: "#005492"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.ebd49a2c683031075bc33c52cce812ba.svg";
export { ForwardRef as ReactComponent };